import { Pipe, PipeTransform } from '@angular/core';
import { BigNumber } from 'bignumber.js';

@Pipe({ name: 'decimalNumber' })
export class DecimalNumber implements PipeTransform {
    transform(numberToRound: number, decimalPlaces = 2): string {
        return new BigNumber(numberToRound).toFixed(decimalPlaces);
    }
}
